import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sblock-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class SblockTestimonialsComponent implements OnInit {
  showTitles = true;
  title = 'Lo que dicen nuestras familias';
  subtitle = 'Testimonios de quienes ya forman parte de la comunidad Adoratrices';
  titlesColor = '#932f29';
  secondaryColor = '#6b7280';

  currentIndex = 0;
  primaryColor = '#932f29';
  isHovered = false;

  testimonials = [
    {
      name: 'María González',
      image: 'https://i.pravatar.cc/150?img=47',
      text: 'La formación que recibe mi hija ha sido excepcional. El acompañamiento humano y espiritual marca una verdadera diferencia en su desarrollo personal y académico.',
      url: '',
      button_text: ''
    },
    {
      name: 'Carlos Hernández',
      image: 'https://i.pravatar.cc/150?img=12',
      text: 'Encontramos una comunidad cálida y comprometida con los valores que buscábamos. El profesorado se entrega por completo a cada estudiante.',
      url: '',
      button_text: ''
    },
    {
      name: 'Lucía Martínez',
      image: 'https://i.pravatar.cc/150?img=32',
      text: 'Los cursos en línea son claros y muy bien estructurados. He podido crecer en mi fe mientras compagino mis estudios con la vida familiar.',
      url: '',
      button_text: ''
    }
  ];

  ngOnInit(): void {}

  hasTitleLink(): boolean {
    return false;
  }

  gotToLink(): void {}

  nextSlide(): void {
    if (this.currentIndex < this.testimonials.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }

  prevSlide(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.testimonials.length - 1;
    }
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  /** Fallback avatar used when a testimonial has no `avatar`/image set */
  readonly defaultAvatar = 'assets/images/empty_user.png';

  getImage(item: any): string {
    return item?.image || this.defaultAvatar;
  }

  getTransform(): string {
    const slideWidthWithGap = 77;
    const offset = 12.5;
    return `translateX(calc(-${this.currentIndex * slideWidthWithGap}% + ${offset}%))`;
  }
}
